export const formatVoteKey = (subCategoryName, brandId) => {
  return `${subCategoryName}-${brandId}`
}
